export default "__VITE_ASSET__DT0PFB65__"